export default {"src":"/_next/static/media/squads.c1ac9445.svg","height":32,"width":156,"blurWidth":0,"blurHeight":0};